import { react2panel } from 'common/util/react2panel';
import { MetricsBetaButtonReact } from './index';
export const MetricsBetaButtonEl = react2panel("metrics-beta-button", MetricsBetaButtonReact, {});